import { IAccount } from '../interface/auth';

export type AppRole = 'superAdmin' | 'staff' | 'seniorAdmin' | 'otherAdmin' | 'contact';

// Same precedence as the backend's getInfoSessionAccountById role CASE.
export const getAppRole = (
  user?: Pick<IAccount, 'isSuperAdmin' | 'isStaff' | 'isSeniorAdmin' | 'isContact'>
): AppRole | undefined => {
  if (!user) return undefined;
  if (user.isSeniorAdmin) return 'seniorAdmin';
  if (user.isContact) return 'contact';
  if (user.isSuperAdmin) return 'superAdmin';
  if (user.isStaff) return 'staff';
  return 'otherAdmin';
};
